import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { AlertService } from '@shared/components/alert/alert.service';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalService } from 'ngx-bootstrap/modal';
declare var $:any;
@Component({
  selector: 'app-splist',
  templateUrl: './splist.component.html',
  styleUrls: ['./splist.component.scss'],
  animations: [
    trigger("fadeIn", [
      state(
        "void",
        style({
          opacity: 0
        })
      ),
      transition("void <=> *", animate(1000))
    ]),
  ]
})
export class SplistComponent implements OnInit {
  branches: any 		= [];
	types: any 			  = [];
	cData: any 			  = [];
	lodingdatas 		  = this.lang.transform('lang_loading');
	admin 				    = JSON.parse(this.ls.getItem('is_admin'));
	page_no:any 		  = localStorage.getItem('M_S_P_N') 	|| 1;
	page_size:any 		= localStorage.getItem('M_S_P_S') 	|| '10';
	searchBranch 		  = localStorage.getItem('M_S_P_B') 	|| "";
	searchType 			  = localStorage.getItem('M_S_P_T') 	|| "";
	searchKey 			  = localStorage.getItem('M_S_P_S_K') || "";
  constructor(public ds: DataService, public lang: LanguagePipe, public ls: LocalStorage, public fb: FormBuilder, public spinner: PreloaderService, public alert: AlertService, public dialog: MatDialog, public modalService: BsModalService) {}
	ngOnInit() {
		this.spinner.show();
		this.get_suppliers();
		this.get_branches();
	}
	public get_branches() {
		this.branches = [];
		this.ds.getActionByUrl([], 'sp/b/suppliers_view').subscribe(res => {
			if (res.status) {
				this.branches = res.records;
			}
		});
	}
	public loadpage(page) {
		this.page_no = page;
		this.page_size = this.page_size;
		this.get_suppliers();
	}
	public loadpagesize(size) {
		this.page_no = 1;
		this.page_size = size;
		this.get_suppliers();
	}
	public load_suppliers() {
		this.page_no = 1;
		this.page_size = '10';
		this.get_suppliers();
	}
	public get_suppliers() {
		localStorage.setItem('M_S_P_N', this.page_no);
		localStorage.setItem('M_S_P_S', this.page_size);
		localStorage.setItem('M_S_P_B', this.searchBranch || ''); // suppliers Branch
		localStorage.setItem('M_S_P_S_K', this.searchKey || ''); // suppliers Search Key
		let param = new FormData();
		param.append('searchBranch', this.searchBranch || '');
		param.append('searchBy', this.searchType || '');
		param.append('searchKey', this.searchKey || '');
		this.ds.postActionByUrl(param, 'sp/get/' + this.page_no + '/' + this.page_size).subscribe(res => {
			this.spinner.hide();
			if (res.status) {
				this.cData = res;
			} else {
				this.lodingdatas = res.error;
				this.cData = [];
			}
		}, error => {
			this.cData = [];
			this.spinner.hide();
			this.lodingdatas = (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error');
		})
	}
	public checkAllItemsCTors(event) {
		if (event.target.checked) {
			$(".suppliers .eachItemCTors").prop("checked", true);
			$(".suppliers .makeback").addClass("bground");
			$(".suppliers .deleteIconDiv").show();
		} else {
			$(".suppliers .eachItemCTors").prop("checked", false);
			$(".suppliers .makeback").removeClass("bground");
			$(".suppliers .deleteIconDiv").hide();
		}
	}
	public checkEachItemCTors(event) {
		if (event.target.checked) {
			const val = event.target.value;
			$(".suppliers .removerow" + val).addClass("bground");
		} else {
			const val = event.target.value;
			$(".suppliers .removerow" + val).removeClass("bground");
		}
		const checkedtotal = [];
		$(".suppliers .eachItemCTors:checked").each(function() {
			checkedtotal.push($(this).val());
		});
		const totalrow = [];
		$(".suppliers .eachItemCTors").each(function() {
			totalrow.push($(this).val());
		});
		if (checkedtotal.length > 0) {
			$(".suppliers .deleteIconDiv").show();
		} else {
			$(".suppliers .deleteIconDiv").hide();
		}
		if (checkedtotal.length === totalrow.length) {
			$(".suppliers #allItemsCTors").prop("checked", true);
		} else {
			$(".suppliers #allItemsCTors").prop("checked", false);
		}
	}
	public deleteBulkDataCTors() {
		const checkedtotal = [];
		$(".suppliers .eachItemCTors:checked").each(function() {
			checkedtotal.push($(this).val());
		});
		if (checkedtotal.length > 0) {
			const dialogRef = this.dialog.open(ConfirmationDialog, {
				disableClose: true,
				width: '400px',
				data: {
					title: this.lang.transform('lang_confirmation'),
					message: this.lang.transform('lang_are_you_sure'),
				}
			});
			dialogRef.afterClosed().subscribe((confirmed: boolean) => {
				if (confirmed) {
					this.spinner.show()
					this.ds.deleteActionByUrl(checkedtotal, "sp/delete").subscribe(
						(data) => {
							this.spinner.hide()
							if (data.status) {
								this.load_suppliers();
								$(".suppliers #allItemsCTors").prop("checked", false);
								$(".suppliers .deleteIconDiv").hide();
								this.ds.dialogf('', data.msg);
							} else {
								this.ds.dialogf('', data.error);
							}
						},
						(error) => {
							this.ds.dialogf('', (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
							this.spinner.hide()
						}
					);
				}
			});
		} else {
			this.ds.dialogf();
		}
	}
}
